import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from "react-select";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import TableContainer from "../../utils/TableContainer";
import SearchField from "../../utils/SearchField";
import Timeformat from "../../utils/Timeformat";
import StaticFunctions from "../../utils/StaticFunctions";

class OperatorEditContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        operator: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            availableTokenIds: [],
            inputError: [],
            inputParams: props.operator,
            tableData: null,
            sortedTableData: null,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompanyOperatorToTokenHistory = this.requestCompanyOperatorToTokenHistory.bind(this);
        this.requestAvailableTokenForOperator = this.requestAvailableTokenForOperator.bind(this);
        this.requestCompaniesForOperator = this.requestCompaniesForOperator.bind(this);
        this.saveEditOperator = this.saveEditOperator.bind(this);
        this.getInput = this.getInput.bind(this);
        this.editSelect = this.editSelect.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);

    }

    componentWillMount() {

        this.requestCompanyOperatorToTokenHistory();
        this.requestAvailableTokenForOperator();
        this.requestCompaniesForOperator();

    }

    requestCompanyOperatorToTokenHistory() {

        if (!this.props.operator) return null;

        const params = {
            action: 'getCompanyOperatorToTokenHistory',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            operatorId: this.props.operator.id_operator,
            companyId: this.state.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    tableData: res,
                    sortedTableData: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestAvailableTokenForOperator() {

        if (!this.state.inputParams) return null;

        const params = {
            action: 'getCompanyOperatorAvailableTokens',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            tokenId: this.state.inputParams.id_token,
            companyId: this.state.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    availableTokenIds: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestCompaniesForOperator() {

        const params = {
            action: 'getCompaniesForUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companies: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    enterSaveEditOperator(event) {

        if (event.keyCode === 13) {
            this.saveEditOperator();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    saveEditOperator() {

        if (!this.state.inputParams) return null;

        const params = {
            action: 'saveCompanyOperator',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            operatorId: parseInt(this.state.inputParams.id_operator),
            name: this.state.inputParams.operator_name,
            info: (this.state.inputParams.operator_info) ? this.state.inputParams.operator_info : null,
            companyId: this.state.inputParams.id_company,
            newTokenId: this.state.inputParams.id_token,
            oldTokenId: this.props.operator.id_token,
            dateDeleted: (this.state.inputParams.dateDeleted) ? parseInt(this.state.inputParams.dateDeleted) : null
        };

        const callback = function(res) {
            if (res.success) {
                alert(this.translate(res.msgKey));

                this.props.changeView('editView');
            } else {
                this.setInputError(res.errors);
            }
        }.bind(this);

        if (params.name && params.companyId !== null) {
            this.api.request('AdminFunctions', params, callback, null);
        } else {
            if (!params.name) this.setInputError('operator_name');
            if (params.companyId === null) this.setInputError('id_company');
        }

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    editSelect(event, key) {

        const inputParams = {...this.state.inputParams};

        inputParams[key] = (event) ? event.value : null;

        this.setState({
            inputParams: inputParams
        });

    }

    getTokenOpt() {

        const availableTokenIds = this.state.availableTokenIds;
        const tokenOpts = [];

        if (this.props.operator && this.props.operator.id_token) {
            tokenOpts.push({
                value: this.props.operator.id_token,
                label: (this.props.operator.token_name) ? this.props.operator.token_name : this.props.operator.id_token
            });
        }

        availableTokenIds.forEach(
            (tokenId) => {
                tokenOpts.push({
                    value: tokenId.id_token,
                    label: (tokenId.token_name) ? tokenId.token_name : tokenId.id_token
                });
            }
        );

        tokenOpts.sort((a,b) => {return a.label.localeCompare(b.label);});

        return tokenOpts;

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    onSearch(value) {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const searchFields = ['id_token'];
        const companyName = this.props.baseData.companies.currentCompany.name;
        const rows = (this.state.tableData) ? this.state.tableData : [];
        const filteredRows = [];

        rows.some(
            (row) => {
                let addToResult = false;
                let last_seen = (row.last_seen) ? Timeformat.fromUnix(row.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '';
                let date_start = (row.date_start) ? Timeformat.fromUnix(row.date_start).getFormatedDate(this.timeFormats.datetime, timezone) : '';
                let date_end = (row.date_end) ? Timeformat.fromUnix(row.date_end).getFormatedDate(this.timeFormats.datetime, timezone) : '';
                let last_modified = (row.last_modified) ? Timeformat.fromUnix(row.last_modified).getFormatedDate(this.timeFormats.datetime, timezone) : '';
                let date_created = (row.date_created) ? Timeformat.fromUnix(row.date_created).getFormatedDate(this.timeFormats.datetime, timezone) : '';
                let date_deleted = (row.date_deleted) ? Timeformat.fromUnix(row.date_deleted).getFormatedDate(this.timeFormats.datetime, timezone) : '';

                if (companyName && StaticFunctions.substringExists(companyName, value)) {
                    addToResult = true;
                } else if (last_seen && StaticFunctions.substringExists(last_seen, value)) {
                    addToResult = true;
                } else if (date_start && StaticFunctions.substringExists(date_start, value)) {
                    addToResult = true;
                } else if (date_end && StaticFunctions.substringExists(date_end, value)) {
                    addToResult = true;
                } else if (last_modified && StaticFunctions.substringExists(last_modified, value)) {
                    addToResult = true;
                } else if (date_created && StaticFunctions.substringExists(date_created, value)) {
                    addToResult = true;
                } else if (date_deleted && StaticFunctions.substringExists(date_deleted, value)) {
                    addToResult = true;
                } else {
                    searchFields.forEach(
                        (searchField) => {
                            if (row[searchField] && StaticFunctions.substringExists(row[searchField], value)) addToResult = true;
                        }
                    );
                }

                if (addToResult) filteredRows.push(row);
            }
        );

        this.setState({
            sortedTableData: filteredRows
        });

    }

    onCancel() {

        this.setState({
            filteredCompanyOperators: this.state.currentCompanyOperators,
        });

    }

    getCompanyOperatorTokenColumns() {

        return [
            {
                key: 'token',
                nameKey: 'token',
                sortType: 'string',
            },
            {
                key: 'tokenName',
                nameKey: 'tokenName',
                sortType: 'string',
            },
            {
                key: 'dateStartToken',
                nameKey: 'tokenValidFrom',
                sortType: 'datetime',
            },
            {
                key: 'dateEndToken',
                nameKey: 'tokenValidTill',
                sortType: 'datetime',
            },
        ];

    }

    getCompanyOperatorTokenRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = (this.state.sortedTableData) ? this.state.sortedTableData : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let dateStart = (rowTemp.date_start) ? Timeformat.fromUnix(rowTemp.date_start).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
            let dateEnd = (rowTemp.date_end) ? Timeformat.fromUnix(rowTemp.date_end).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rows.push({
                id: i,
                token: rowTemp.id_token,
                tokenName: rowTemp.token_name,
                dateStartToken: dateStart,
                dateEndToken: dateEnd,
            });
        }

        return rows;

    }

    render() {

        if (!this.state.inputParams) return <LoadingSplash />;

        const tokenOpts = this.getTokenOpt();
        const inputParams = this.state.inputParams;
        const tableColumns = this.getCompanyOperatorTokenColumns();
        const tableRows = this.getCompanyOperatorTokenRows();

        return (
            <div className="formSettings">
                <div className="ma-bo-20 clearfix">
                    <nav>
                        <h1>{this.translate('operatorSettings')}</h1>
                    </nav>

                    <div className="col-xs-12 col-lg-4">
                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('id')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="id"
                                                value={inputParams.id_operator}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('name')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="operator_name"
                                                value={inputParams.operator_name}
                                                isRequired={true}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('info')}</td>

                                        <td className="text-left">
                                            <TextAreaField
                                                name="operator_info"
                                                value={inputParams.operator_info}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('token')}</td>

                                        <td className="text-left">
                                            <Select
                                                name="id_token"
                                                className={['chosen-container', 'chosen-container-single', this.checkInputError('id_token')].join(' ').trim()}
                                                style={{width: '260px'}}
                                                options={tokenOpts}
                                                value={tokenOpts.find(o => String(o.value) === String(inputParams.id_token)) || null}
                                                clearable={true}
                                                noResultsText={this.translate('noResultsFound')}
                                                placeholder={this.translate('select') + '...'}
                                                onChange={(event) => this.editSelect(event, 'id_token')}
                                            />
                                        </td>

                                        <td className="optionBar">
                                            <a className="optionClear" onClick={() => this.editSelect(null, 'id_token')} style={{marginLeft: 5}}>&nbsp;</a>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan webElement">&nbsp;</td>

                                        <td className="text-left">
                                            <a className="formButton" onClick={() => this.props.changeView('editView')}>
                                                {this.translate('cancel')}
                                            </a>

                                            <a className="formButton" onClick={() => this.saveEditOperator()} onKeyDown={(event) => this.enterSaveEditOperator(event)}>
                                                {this.translate('save')}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="ma-bo-20 clearfix">
                    <div>
                        <nav>
                            <h1>{this.translate('history')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchOperatorEdit"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>

                        <div className="col-lg-12">
                            <TableContainer
                                baseData={this.props.baseData}
                                columns={tableColumns}
                                rows={tableRows}
                                fillGaps="-"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

export default OperatorEditContainer;
